/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Select_Inverse_ButtonInputs */

const en_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Inverse`)
};

const fr_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser la selection`)
};

const de_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertieren auswählen`)
};

const it_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona Inverso`)
};

const ru_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите обратную операцию`)
};

const es_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar Inverso`)
};

const zh_cn2_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择反向`)
};

const ja_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆を選択`)
};

const hi_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनवर्स का चयन करें`)
};

const pt_pt2_paste_attributes_select_inverse_button = /** @type {(inputs: Paste_Attributes_Select_Inverse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione Inverso`)
};

/**
* | output |
* | --- |
* | "Select Inverse" |
*
* @param {Paste_Attributes_Select_Inverse_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_select_inverse_button = /** @type {((inputs?: Paste_Attributes_Select_Inverse_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Select_Inverse_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_select_inverse_button(inputs)
	if (locale === "de") return de_paste_attributes_select_inverse_button(inputs)
	if (locale === "it") return it_paste_attributes_select_inverse_button(inputs)
	if (locale === "ru") return ru_paste_attributes_select_inverse_button(inputs)
	if (locale === "es") return es_paste_attributes_select_inverse_button(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_select_inverse_button(inputs)
	if (locale === "ja") return ja_paste_attributes_select_inverse_button(inputs)
	if (locale === "hi") return hi_paste_attributes_select_inverse_button(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_select_inverse_button(inputs)
	return en_paste_attributes_select_inverse_button(inputs)
});